import React, { useEffect, useState } from 'react';
import './ScrollTop.css';

function ScrollTop() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setActive(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={`back-to-top ${active ? 'active' : ''}`}
      aria-label="Voltar ao topo da página"
    >
      <button onClick={handleClick}>
        <span className="fa fa-chevron-up"></span>
        <span className="sr-only">Voltar ao topo da página</span>
      </button>
    </div>
  );
}

export default ScrollTop;
